import { Component, OnInit, AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ApiService } from '../api.service';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-case-practice-p-and-o',
  templateUrl: './case-practice-p-and-o.component.html',
  styleUrls: ['./case-practice-p-and-o.component.css']
})
export class CasePracticePAndOComponent implements OnInit {
    isTencent = false; // 用于判断是否为腾讯对接
    learningPathId: number;
    practiceMetaId: number;

    page: string;

    practiceList: any;
    practiceId: number;

    exerciseId: number;

    practiceIndex: number;

  // 用于判断用户类型是否为访客
  userType: string;
  type: string;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private apiService: ApiService,
      private commonService: CommonService
  ) { }

  ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🚚🚚🚚🚚🚚🚚');
    // -------------------------------------------------------------------
    this.userType = window.sessionStorage.getItem('userType');
    this.route.queryParams.subscribe(queryParams => {
      this.type = queryParams['type'];
    });
      this.route.params.subscribe(params => {
          this.learningPathId = params['learningPathId'];
          this.practiceMetaId = params['practiceMetaId'];
          this.exerciseId = params['exerciseId'];
          if (this.exerciseId > 0 || localStorage.getItem('isIframe')){
              this.page = 'previous';
          }
          else{
              this.page = 'list';
          }


          this.apiService.ajax({
              'type': 'GET',
              'url': '/sr/createAndGet/' + this.learningPathId + '/' + this.practiceMetaId
          }).subscribe(result => {
              this.practiceList = result.exercise;
              this.practiceId = result.id;
            this.apiService.ajax({
              'type': 'post',
              'url': 'sr/practice/correctLearningPath/' + this.practiceId,
              'data': {'practiceId': this.practiceId}
            }).subscribe(result => {
              console.log(result);
            });
          });

          /*this.page = 'event';
          this.practiceList = this.getMockData().exercise;
          this.practiceId = this.getMockData().id;*/
      });

    setTimeout(() => {
      if (this.type){
        $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
      }
    }, 500);
  }

    goToEvent(){
      this.page = 'event';
    }

    setPracticeIndex(i){
        this.practiceIndex = i;
        this.exerciseId = this.practiceList[this.practiceIndex].id;
    }

    goToNextStep(i){
      if (i == 1){
        this.page = 'previous';
      }else{
        this.page = 'event';
      }
    }


    // getMockData() {
    //     return {
    //         "id": 1955,
    //         "exercise": [{
    //             "id": 2253,
    //             "title": "\u62a5\u544a\u8fdf\u4ea4\uff0c\u8c01\u4e4b\u8fc7?",
    //             "description": "\u4e00\u4e2a\u52e4\u594b\u4f46\u73bb\u7483\u5fc3\u7684\u5458\u5de5\u7531\u4e8e\u8fdf\u4ea4\u62a5\u544a\u5f15\u53d1\u7684\u4e00\u7cfb\u5217\u7684\u6545\u4e8b",
    //             "status": 1
    //         }, {
    //             "id": 2254,
    //             "title": "\u5458\u5de5\u60c5\u7eea\uff0c\u5982\u4f55\u5316\u8d1f\u4e3a\u6b63",
    //             "description": "\u5982\u4f55\u8f85\u5bfc\u4e00\u4e2a\u5e26\u6709\u8d1f\u9762\u60c5\u7eea\u7684\u8001\u5458\u5de5\uff1f\u8fd9\u662f\u4e2a\u5e38\u89c1\u7684\u95ee\u9898\uff0c\u8981\u600e\u4e48\u505a\u5462\uff1f",
    //             "status": 1
    //         }]
    //     }
    // }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o/case-practice-p-and-o.component.ts